import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";

import { useAuth } from "context/authContext";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Box } from "@mui/material";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    <DashboardLayout>
      <DashboardNavbar />
      <Box padding={0.5}></Box>
      {React.cloneElement(children, { locationState: location.state })}
    </DashboardLayout>
  ) : (
    <Navigate to="/authentication/sign-in" />
  );
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired, // Validate that children is a React node and required
};

export default ProtectedRoute;
